<template>
  <div class="mains">
    <div class="tiyouimg">
      <img style="object-fit: cover;width: 100%" src="../assets/img/szjc/szjc1.png"/>
    </div>
    <div style="margin-top: 90px;height: 113px;margin-left: 17px">
      <img style="object-fit: fill;width: 50%" src="../assets/img/szjc/szjc2.png" alt="">
    </div>
    <div style="padding: 0 15%;display: flex;justify-content: center;margin-top: 15px">
      <img src="../assets/img/szjc/szjc3.png" alt="">
    </div>

    <div style="margin-top: 90px;height: 113px;margin-left: 17px">
      <img style="object-fit: fill;width: 50%" src="../assets/img/szjc/szjc4.png" alt="">
    </div>

    <div class="anli" v-for="(item,i) in list">
      <div style="display: flex;height: 50px;width: 100%">
        <div style="height: 48px">
          <img :src="item.index" alt="">
        </div>
        <div style="
        height: 35px;
        font-size: 32px;

        font-weight: bold;
        color: #1886AE;
        line-height: 37px;
        margin-left: 26px">
          {{item.title}}
        </div>
      </div>
      <div style="height: 100px;width: 100%;font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;margin-top: 24px">
        &nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}
        <br>
        &nbsp;&nbsp;&nbsp;&nbsp;{{item.pt}}
      </div>

      <div class="imgs" style="margin-top: 28px;height: 300px;display: flex;justify-content: space-around">
        <div class="imgsdiv" >
          <img :src="item.img1" alt="">
        </div>
        <div class="imgsdiv" >
          <img :src="item.img2" alt="">
        </div>
        <div class="imgsdiv" >
          <img :src="item.img3" alt="">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Szjc",
  data(){
    return{
      list:[
        {
          index: require("../assets/img/szjc/szjc5.png"),
          title:"Hadoop搭建与运维",
          content: "本书分6个项目19个任务，详细介绍了Hadoop的基本信息和操作方法，包含Hadoop系统安装、Hadoop中HDFS数据读写操作、YARN资源管理、MapReduce处理海量数据、Python数据爬取以及Hive数据仓库。",
          pt: "配套课件：6个PPT、7个微课、18个操作视频",
          img1: require("../assets/img/szjc/szjc6.png") ,
          img2: require("../assets/img/szjc/szjc7.png"),
          img3: require("../assets/img/szjc/szjc8.png"),
        },
        {
          index: require("../assets/img/szjc/szjc9.png"),
          title:"Tableau数据可视化实战应用",
          content: "本书分7个项目20个任务，详细介绍了数据可视化的基本知识和应用，Tableau中常见基础工具的使用方法，12种常用图表的特点、使用场景与绘制方法，数据的处理技术，创建和制作仪表与故事的方法。同时，最后以一个项目实战应用为主导，通过3个主题，完成了对项目数据源的处理、数据可视化的呈现、数据分析报告的制作。 ",
          pt: "配套课件：18个教案、18个PPT、7个微课、18个操作视频",
          img1: require("../assets/img/szjc/szjc10.png") ,
          img2: require("../assets/img/szjc/szjc11.png"),
          img3: require("../assets/img/szjc/szjc12.png"),
        },
        {
          index: require("../assets/img/szjc/szjc13.png"),
          title:"职业素养",
          content: "本课程分19个项目，结合企业对员工职业素养的实际需求，以及毕业生在进入职场前后，所需要培养的能力和需要掌握的习惯的进阶时间线。团队汇集在各种不同性质的企业中积淀的职业素养技能，采用生动有趣的画面、启发性强的实践活动，来着力打造的精品课程。 ",
          pt: "配套课件：36个教案、36个PPT",
          img1: require("../assets/img/szjc/szjc14.png") ,
          img2: require("../assets/img/szjc/szjc15.png"),
          img3: require("../assets/img/szjc/szjc16.png"),
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.mains{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  flex-direction: column;
  display: flex;
  .tiyouimg{
    width: 100%;
  }
  .anli{
    margin-bottom: 50px;
    //width: 70%;
    padding: 0 15%;
    display: flex;
    flex-direction: column;
    height: 100%
  }
}
.imgs{
  .imgsdiv{
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
}
</style>
